import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './captureSelfSignUpLeadMutation.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type CaptureSelfSignUpLeadMutation_Mutation = {
  __typename?: 'Mutation',
  captureSelfSignUpLead: boolean
};


export type CaptureSelfSignUpLeadMutationVariables = Types.Exact<{
  input: Types.SelfSignUpCaptureLeadInput;
}>;


export type CaptureSelfSignUpLeadMutation = CaptureSelfSignUpLeadMutation_Mutation;


export const CaptureSelfSignUpLeadDocument = /*#__PURE__*/ document as unknown as DocumentNode<CaptureSelfSignUpLeadMutation, CaptureSelfSignUpLeadMutationVariables>;

export type CaptureSelfSignUpLeadMutationFn = ApolloReactCommon.MutationFunction<CaptureSelfSignUpLeadMutation, CaptureSelfSignUpLeadMutationVariables>;

/**
 * __useCaptureSelfSignUpLeadMutation__
 *
 * To run a mutation, you first call `useCaptureSelfSignUpLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureSelfSignUpLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureSelfSignUpLeadMutation, { data, loading, error }] = useCaptureSelfSignUpLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCaptureSelfSignUpLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CaptureSelfSignUpLeadMutation, CaptureSelfSignUpLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CaptureSelfSignUpLeadMutation, CaptureSelfSignUpLeadMutationVariables>(CaptureSelfSignUpLeadDocument, options);
      }
export type CaptureSelfSignUpLeadMutationHookResult = ReturnType<typeof useCaptureSelfSignUpLeadMutation>;
export type CaptureSelfSignUpLeadMutationResult = ApolloReactCommon.MutationResult<CaptureSelfSignUpLeadMutation>;
export type CaptureSelfSignUpLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<CaptureSelfSignUpLeadMutation, CaptureSelfSignUpLeadMutationVariables>;